import {
  FETCH_CANDIDATE_APPLIED_JOBS_REQUEST,
  FETCH_CANDIDATE_APPLIED_JOBS_SUCCESS,
  FETCH_CANDIDATE_APPLIED_JOBS_FAILURE,
} from "../../actionTypes";

export const fetchCandidateAppliedJobsRequest = (data) => ({
  type: FETCH_CANDIDATE_APPLIED_JOBS_REQUEST,
  payload: data,
});

export const fetchCandidateAppliedJobsSuccess = (data) => ({
  type: FETCH_CANDIDATE_APPLIED_JOBS_SUCCESS,
  payload: data,
});

export const fetchCandidateAppliedJobsFailure = (error) => ({
  type: FETCH_CANDIDATE_APPLIED_JOBS_FAILURE,
  payload: error,
});


